import { forwardRef } from 'react';

import { Input } from 'ui/atoms';
import { InputProps } from 'ui/atoms/input/Input.types';

export const ForwardRefInput = forwardRef((props: Omit<InputProps, 'inputRef'>, ref) => (
  <Input {...props} inputRef={ref} />
));
